import React, { useCallback } from 'react'
import { FormControlLabel, Radio, RadioGroup } from '@mui/material'
import { BackgroundType } from '../../types'

interface BackgroundStepProps {
  backgroundType: BackgroundType
  setBackgroundType: (value: BackgroundType) => void
}

const BackgroundLabels = {
  [BackgroundType.None]: 'Do not remove background',
  [BackgroundType.Remove]: 'Remove background',
}

const BackgroundStep: React.FC<BackgroundStepProps> = ({ backgroundType, setBackgroundType }) => {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => setBackgroundType(Number(e.target.value)),
    [setBackgroundType]
  )

  return (
    <RadioGroup value={backgroundType} onChange={handleChange} name='backgroundType'>
      {Object.entries(BackgroundLabels).map(([key, label]) => (
        <FormControlLabel key={key} value={Number(key)} control={<Radio color='primary' />} label={label} />
      ))}
    </RadioGroup>
  )
}

export default BackgroundStep
